export const SOCIAL_LINKS = {
  facebook: "https://www.facebook.com/4x4vert",
  email: "annedepiesse@4x4vert.be",
  phone: "0498 531 531",
};
